import React, { useEffect, useRef, useState } from "react"
import PropTypes from 'prop-types'
import Button from 'react-bootstrap/Button'
import { v4 as uuidv4 } from 'uuid'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { Translate } from "../Components/Translator.jsx"
import { IsEmptyString, LocalizedDateTime, TimeDifferenceInMinutesAndSeconds, ucfirst } from "../Components/GeneralFunctions.jsx"
import { CallData, EmbeddedGetEmbeddedRecognition,EmbeddedSetEmbeddedRecognition,EmbeddedGetEmbeddedRecognitionSelectedIndex,EmbeddedSetEmbeddedRecognitionSelectedIndex } from "./EmbeddedSupport.jsx"

import CallHistory from "../Components/CallHistory.jsx"
import SpeedDials from "../Components/SpeedDials.jsx"

import CallPng from './Assets/embedded_call.png'
import ClearCallPng from './Assets/embedded_clearcall.png'
import CopyNumberPng from './Assets/embedded_copynumber.png'

const Embedded = (props) => {
  
  const [mRepainter, SetRepainter] = useState("")

  const [mTab, SetTab] = useState(localStorage.getItem("EmbeddedTab") || "Search")
  const [mError, SetError] = useState("") 

  const [mBroadcastChannel, SetBroadcastChannel] = useState(new BroadcastChannel("cloudctiwebclient2024_embedded"))

  useEffect(() => {
    mBroadcastChannel.addEventListener("message", function(event) {
      if (event.data === "repaint")
      {   
        setTimeout(() => {
          SetRepainter(uuidv4())
        }, 500)      
      }
    });

    props.OnInitialize()
    return Finalize()
  }, []);   

  const ProcessNewCallEvent = (calldata) =>
  {
    const lastcallid = localStorage.getItem("embedded_lastcallid") || ""
    const lastcalleventid = localStorage.getItem("embedded_lastcalleventid") || ""
    if (calldata.id !== lastcallid)
    {
      //this is the first event for this call 
      localStorage.setItem("embedded_lastcallid", calldata.id)
      localStorage.setItem("embedded_lastcalleventid",calldata.id + "." + calldata.state)
      props.OnSearchContacts(calldata.opn).then((embeddedcontacts) => {
        if (embeddedcontacts !== null)
        {
          try { EmbeddedSetEmbeddedRecognition(JSON.stringify(embeddedcontacts)) } catch { }
          EmbeddedSetEmbeddedRecognitionSelectedIndex(0)
          if ((embeddedcontacts != null) && (embeddedcontacts.length > 0))
          {
              const script = {ScreenpopUrl: props.OnScreenpopUrlCreate(embeddedcontacts[0]), Name: "Open " + ucfirst(embeddedcontacts[0].type)}
              props.OnSetHistoryCallRecognition(calldata.id, embeddedcontacts[0].name, props.Crm, [script])
          }  
        }
        props.OnNewCallEvent(calldata,embeddedcontacts) 
        Repaint()
      })            
    }
    else if (calldata.id + "." + calldata.state !== lastcalleventid)
    {
      //this is not the first event for this call, but it is the first event for this call with this state
      localStorage.setItem("embedded_lastcalleventid", calldata.id + "." + calldata.state)      
      props.OnNewCallStateEvent(calldata)
    }
  }

  const CreateAndOpenContact = (number, type = "") => 
  {
    try 
    {
        props.OnCreateContact(number,type).then((contact) => {
          if (contact != null)
          {
              EmbeddedSetEmbeddedRecognition(JSON.stringify([contact]))
              EmbeddedSetEmbeddedRecognitionSelectedIndex(0)

              SetCallHistoryRecognition() //sets localstorage embedded_lastcallselectedrecognitionid

              Repaint()
              props.OnOpenContact(contact,type)  
          }   
        })
    } 
    catch (error) 
    {
        console.error("Failed to create new contact: ", error);
    }
  }

  const Finalize = () =>
  {
    if (props.OnFinalize != null)
    {
      props.OnFinalize()
    }
    else
    {
      return null
    }
  }

  const NextRecognition = (aEvent, aRecognition,aRecognitionSelectedIndex) =>
  {
    aEvent.stopPropagation()
    const CurrentIndex = aRecognitionSelectedIndex
    const NewIndex = CurrentIndex < aRecognition.length - 1 ? CurrentIndex + 1 : 0
    localStorage.setItem("embedded_lastcallselectedrecognitionindex", NewIndex)
    SetCallHistoryRecognition()
    Repaint()
  }

  const PreviousRecognition = (aEvent, aRecognition,aRecognitionSelectedIndex) =>
  {
    aEvent.stopPropagation()
    const CurrentIndex = aRecognitionSelectedIndex ?? 0
    const NewIndex = CurrentIndex > 0 ? CurrentIndex - 1 : aRecognition.length - 1
    localStorage.setItem("embedded_lastcallselectedrecognitionindex", NewIndex)
    SetCallHistoryRecognition()
    Repaint()
  }

  const Repaint = () => 
  {
    console.log("Repaint")
    mBroadcastChannel.postMessage("repaint")
    SetRepainter(uuidv4())
  }
  
  const SetCallHistoryRecognition = () =>
  {
    try
    {
        const ActiveCallString = localStorage.getItem("newestcallevent")
        const ActiveCall = !IsEmptyString(ActiveCallString) ? JSON.parse(ActiveCallString) : null
        if (ActiveCall != null)
        {
            const RecognitionBuffer = EmbeddedGetEmbeddedRecognition()
            if ((RecognitionBuffer != null) && (RecognitionBuffer.length > 0))
            {
                const RecognitionBufferIndex = EmbeddedGetEmbeddedRecognitionSelectedIndex()
                if (RecognitionBuffer.length > RecognitionBufferIndex)
                {
                  const script = {ScreenpopUrl: props.OnScreenpopUrlCreate(RecognitionBuffer[RecognitionBufferIndex]), Name: "Open " + ucfirst(RecognitionBuffer[RecognitionBufferIndex].type)}
                  props.OnSetHistoryCallRecognition(ActiveCall.CallId, RecognitionBuffer[RecognitionBufferIndex].name, props.Crm, [script])
                }
            }
        }
    }
    catch {}
  }
  
  //EVENTS

  const EmbeddedTabChange = (aTab) =>
  {
    SetTab(aTab)
    localStorage.setItem("EmbeddedTab",aTab)
  }

  //PAINT

  const PaintMultipleRecognition = (aRecognition,aRecognitionSelectedIndex) => 
  {
    const RecognitionSelectedIndex = aRecognitionSelectedIndex ?? 0
    const SelectedRecognition = aRecognition[RecognitionSelectedIndex]

    return <> 
      <div className="notification clickableshadow" style={{ padding: "6px"}} onClick={() => props.OnOpenContact(SelectedRecognition)}>
        <table style={{width: "100%"}}>
        <tbody>
        <tr>
          <td width="48" valign="center"><img style={{ width: "48px"}} src={props.OnGetContactIcon(SelectedRecognition)}/></td>
          <td width="10"/>
          <td width="*" valign="center"><b style={{ fontSize: "22px", fontWeight: "bolder"}}>{props.OnGetContactDisplayName(SelectedRecognition)}</b></td>
          <td width="10"/>
          <td width="48" valign="center"><button style={{ width: "48px", height: "48px"}} onClick={(evt) => PreviousRecognition(evt, aRecognition,RecognitionSelectedIndex)}>&lt;</button></td>
          <td width="10"/>
          <td width="48" valign="center"><button style={{ width: "48px", height: "48px"}} onClick={(evt) => NextRecognition(evt, aRecognition,RecognitionSelectedIndex)}>&gt;</button></td>
        </tr>
        </tbody>
        </table> 
      </div>
      <div align="right" style={{ color: "gray", paddingRight: "6px"}}>{(RecognitionSelectedIndex+1)}/{aRecognition.length}</div>
    </>
  }

  const PaintNotRecognized = () => 
  {
    return <div className="notification" style={{paddingTop: "18px", paddingBottom: "18px"}}>{Translate("Number not recognized")}</div>
  }

  const PaintSearchTab = (call) =>
  {
    const callData = CallData(call) 

    //Recognition data
    const EmbeddedRecognition = EmbeddedGetEmbeddedRecognition()
    const EmbeddedRecognitionSelectedIndex = EmbeddedGetEmbeddedRecognitionSelectedIndex()

    //Embedded error or phone error
    const error = !IsEmptyString(mError) ? mError : !IsEmptyString(props.PhoneApiError) ? Translate("Failed to subscribe for phone events") + <br/> + Translate("Error") + ": " + props.PhoneApiError: ""

    return <table width="100%" height="100%" cellPadding="0" cellSpacing="0">
    <tbody>
      <tr height="30">
        <td valign="top" align="left" className="padded10">
          {!IsEmptyString(error) ? <div className="notificationerror">{error}</div> :
          IsEmptyString(callData.id) ? 
            <div className="notification" style={{paddingTop: "8px", paddingBottom: "8px"}}>{Translate("No incoming call information available")}</div> :
            <span>
              <div className="notification" style={{paddingTop: "8px", paddingBottom: "8px"}}>                          
                <b>{(callData.inbound ? Translate("Incoming call from") : Translate("Outgoing call to")) + " " + callData.opn}</b>
                <br/>                                               
                <div className="smalltext">{LocalizedDateTime(call?.StartTime ?? Date.now())}</div>   
              </div>
              <CopyToClipboard text={callData.opn}><img className="clickable" src={CopyNumberPng} title={Translate("Copy number")} style={{ width: "40px", marginTop: "4px", cursor: "pointer"}}/></CopyToClipboard>
              <>&nbsp;<img className="clickable" src={CallPng} title={Translate("Call")} style={{ width: "40px", marginTop: "4px", cursor: "pointer"}} onClick={() => props.OnMakeCall(callData.opn)}/></>
              {props.OnGetAdditionalCallActions != null ? props.OnGetAdditionalCallActions(callData) : <></>}
              {<>&nbsp;<img className="clickable" src={ClearCallPng} title={Translate("Clear call")} style={{ width: "40px", marginTop: "4px", cursor: "pointer"}} onClick={() => props.OnClearCall()}/></>} 
            </span>
            } 
        </td>
      </tr> 
      <tr style={{ borderTop: "1px black solid"}}>
        <td valign="top" align="left" className="padded10">
          {IsEmptyString(error) && !IsEmptyString(callData.id) ? 
            <span>                                         
              {
                EmbeddedRecognition === null ? "Searching for recognition" :
                EmbeddedRecognition.length > 1 ? PaintMultipleRecognition(EmbeddedRecognition,EmbeddedRecognitionSelectedIndex) : 
                EmbeddedRecognition.length > 0 ? PaintSingleRecognition(EmbeddedRecognition[0]) : 
                PaintNotRecognized() 
              }
              {props.OnGetAdditionalCallInfoNode != null ? <div><br/>{props.OnGetAdditionalCallInfoNode(callData)}</div> : <></>}
            </span> 
            : <></>
            } 
        </td>
      </tr> 
      </tbody>
    </table>
  }

  const PaintSingleRecognition = (contact) => 
  {
    return <div className="notification clickableshadow" style={{ padding: "6px"}} onClick={() => props.OnOpenContact(contact)}>
        <table>
          <tbody>
          <tr>
            <td width="48" valign="center"><img style={{ width: "48px"}} src={props.OnGetContactIcon(contact)}/></td>
            <td width="10"/>
            <td width="*" valign="center"><b style={{ fontSize: "22px", fontWeight: "bolder"}}>{props.OnGetContactDisplayName(contact)}</b></td>
          </tr>
          </tbody>
      </table> 
    </div>
  }

  //Get the latest call, if one exists
  let Call = null
  try
  {
    const CallString = localStorage.getItem("newestcallevent")
    Call = !IsEmptyString(CallString) ? JSON.parse(CallString) : null
    if ((props.PrimaryTab) && (Call != null) && !IsEmptyString(Call.CallId) && !IsEmptyString(Call.State))
    {
      ProcessNewCallEvent(CallData(Call))
    }
  }
  catch {}

  return <table width="100%" height="100%">        
    <tbody>
    <tr height="24">
        <td width="33%" className={mTab === "Search" ? "mobilemodewindow mobilemodewindowselected embeddedtabselected" : "mobilemodewindow"} onClick={() => EmbeddedTabChange("Search")}><span className={mTab === "Search" ? "up3px embeddedtabselected" : "up3px"}>{Translate("Search").toUpperCase()}</span></td>
        <td width="34%" className={mTab === "History" ? "mobilemodewindow mobilemodewindowselected embeddedtabselected" : "mobilemodewindow"} onClick={() => EmbeddedTabChange("History")}><span className={mTab === "History" ? "up3px embeddedtabselected" : "up3px"}>{Translate("History").toUpperCase()}</span></td>
        <td width="33%" className={mTab === "Speed dial" ? "mobilemodewindow mobilemodewindowselected embeddedtabselected" : "mobilemodewindow"} onClick={() => EmbeddedTabChange("Speed dial")}><span className={mTab === "Speed dial" ? "up3px embeddedtabselected" : "up3px"}>{Translate("Speed dial").toUpperCase()}</span></td>
    </tr>
    <tr><td colSpan="3"><ToastContainer/></td></tr>
    <tr height="*">

        {mTab === "Search" ? 

            <td colSpan="3" valign="top">       
              {PaintSearchTab(Call)}
            </td>

        : (mTab === "History" ? 

            <td colSpan="3" align="left" valign="top">
              <CallHistory 
                Calls={props.Calls}
                QueryingRecognitionNumbers={props.RecognitionCacheQueryingNumbers}
                SpeedDials={((props.SpeedDials === undefined) || (props.SpeedDials === null) || !props.SpeedDials) ? [] : props.SpeedDials} 
                ShowHeader={false} 
                AddSearch={true}
                OnMakeCall={(number, name, application, scripts) => props.OnMakeCall(number, name, application, scripts)} 
                OnAddToSpeedDial={(number, name, application, scripts) => props.OnAddToSpeedDial(number, name, application, scripts)}
                OnRemoveFromSpeedDial={(number) => props.OnRemoveFromSpeedDial(number)} 
                OnRemoveFromCallHistory={(callid) => props.OnRemoveFromCallHistory(callid)}
                OnEmbeddedScreenpop={(url) => props.OnScreenpopUrlExecute(url)}
              />
            </td>

        :

            <td colSpan="3" align="left" valign="top">                      
              <SpeedDials 
                SpeedDials={((props.SpeedDials === undefined) || (props.SpeedDials === null) || !props.SpeedDials) ? [] : props.SpeedDials} 
                ShowHeader={false} 
                OnMakeCall={(number, name, application, scripts) => props.OnMakeCall(number, name, application, scripts)} 
                OnRemoveFromSpeedDial={(number) => props.OnRemoveFromSpeedDial(number)}
              />
            </td>)
          }
    </tr>
    </tbody>
    </table>
}

Embedded.propTypes = {
  //properties directly inherited from the Embedded<crm> props
  Calls: PropTypes.array,
  SecurityToken: PropTypes.string,
  PhoneApiError: PropTypes.string,
  LastCallEventId: PropTypes.string, //used for repainting purposes. updates on call event
  Brand: PropTypes.string,
  RecognitionCacheQueryingNumbers: PropTypes.array,
  SpeedDials: PropTypes.array,
  PrimaryTab: PropTypes.bool,
  OnAddToSpeedDial: PropTypes.func,
  OnClearCall: PropTypes.func,
  OnMakeCall: PropTypes.func,
  OnRemoveFromCallHistory: PropTypes.func,
  OnRemoveFromSpeedDial: PropTypes.func,
  OnSetHistoryCallRecognition: PropTypes.func,

  //properties directly implemented by the Embedded<crm>
  Crm: PropTypes.string, //name of the crm
  OnCreateContact: PropTypes.func, //(number,type) => contact
  OnFinalize: PropTypes.func, //()
  OnGetContactDisplayName: PropTypes.func, //(call) => contact
  OnGetContactIcon: PropTypes.func, //(call) => contact
  OnGetAdditionalCallActions: PropTypes.func, //(call) => <></>
  OnGetAdditionalCallInfoNode: PropTypes.func, //(call) => <></>
  OnInitialize: PropTypes.func, //()
  OnOpenContact: PropTypes.func, //(contact)
  OnNewCallEvent: PropTypes.func, //(calldata,contacts)
  OnNewCallStateEvent: PropTypes.func, //(calldata)
  OnScreenpopUrlCreate: PropTypes.func, //(contact)
  OnScreenpopUrlExecute: PropTypes.func, //(url)
  OnSearchContacts: PropTypes.func, //number => contact[]
}

export default Embedded